import React from 'react';
import '../../styles/sections.css';
import '../../styles/climbor die.css';
import '../../styles/gameshowcase.css';

const GameShowcase = () => (
  <div className="gameshowcase-section">
    <div className="section-header">
      <h2>GAME SHOWCASE</h2>
      <div className="underline"></div>
    </div>
    <div className="gameshowcase-content">
      <div className="game-info">
        <h3>Core Gameplay</h3>
        <p>
          Players start at the bottom of a massive tower and must climb to the top while escaping the rising gas. 
          Each map features moving platforms, timed jumps, and environmental challenges that push both speed and precision.
        </p>
        
        <h3>Key Features</h3>
        <ul>
          <li>Challenging parkour-based obstacle design</li>
          <li>Power-ups: Super Jump, Low Gravity, Float, Rocket Boost</li>
          <li>Permanent upgrades: Double Coins, Second Chance</li>
          <li>Global leaderboards with exclusive glow rewards</li>
          <li>Customizable skins, glows, and emotes</li>
          <li>Checkpoints to save progress during climbs</li>
          <li>Multiplayer races and social features for friends</li>
        </ul>
      </div>
    </div>
  </div>
);

export default GameShowcase;
